<div class="group">
  <div class="label" [ngClass]="classLabel">{{ label }}</div>
  @if (counter >= 0) {
    <div class="counter" [ngClass]="classCounter">{{ counter }}</div>
  }
</div>
